import React, { useState, useEffect } from 'react';
import LocationSelectorBase from './LocationSelectorBase';

const LOCAL_STORAGE_KEY = 'tour_location_state';

const getStoredLocation = () => {
  try {
    return JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY)) || {};
  } catch {
    return {};
  }
};

const LocationSelectorWithCache = ({
  clientId,
  onChange,
  spaceResetKey = 0,
  hideFloorSpace = false,
}) => {
  const stored = getStoredLocation();

  const [state, setState] = useState({
    projectId: stored.project || '',
    lotId: stored.lot || '',
    buildingId: stored.building || '',
    floorId: stored.floor || '',
    spaceId: stored.space || '',
  });

  useEffect(() => {
    if (spaceResetKey) {
      setState(prev => ({
        ...prev,
        spaceId: '', // Only reset space
      }));
    }
  }, [spaceResetKey]);

  const handleChange = updated => {
    setState(updated);

    // ✅ Immediately save to localStorage on any field change
    localStorage.setItem(
      LOCAL_STORAGE_KEY,
      JSON.stringify({
        project: updated.projectId,
        lot: updated.lotId,
        building: updated.buildingId,
        floor: updated.floorId,
        space: updated.spaceId,
      })
    );

    // ✅ Map field names correctly for ImageSelector and others
    onChange?.({
      selectedProject: updated.projectId,
      selectedLot: updated.lotId,
      selectedBuilding: updated.buildingId,
      selectedFloor: updated.floorId,
      selectedSpace: updated.spaceId,
    });
  };

  return (
    <LocationSelectorBase
      clientId={clientId}
      {...state}
      onChange={handleChange}
      hideFloorSpace={hideFloorSpace}
      forceProjectSelectionAlways={true} // 👈 we'll add this flag to LocationSelectorBase next
    />
  );
};

export default LocationSelectorWithCache;
